// Dependencies
import React from "react";

// Material UI Components
import Typography from "@mui/material/Typography";

// Components
import Image from "components/image-containers/Image/Image.component";
import { thumbnailPlayIcon } from "assets/externalImages";

// styles
import { useStyles } from "./VideoThumbnail.styles";

const VideoThumbnail = ({ medium, index, setIndex }) => {
  const classes = useStyles();

  return (
    <div className={classes.thumbnailContainer} data-component="VideoThumbnail">
      <div className={classes.thumbnailImageContainer}>
        <Image
          width={50}
          height={50}
          className={classes.thumbnailPlayIcon}
          src={thumbnailPlayIcon}
          onClick={() => setIndex(index)}
          alt="video-thumbnail-play"
        />
        <Image
          width={medium.thumbnailWidth}
          height={medium.thumbnailHeight}
          alt="Video thumbnail"
          className={classes.thumbnailImage}
          src={medium.thumbnailUrl}
        />
      </div>
      <Typography
        variant="h4"
        className={classes.thumbnailTitle}
        data-cy="video-gallery-title"
      >
        {medium.title}
      </Typography>
    </div>
  );
};

export default VideoThumbnail;
